module.exports = __webpack_public_path__ + "img/about_chat_and_meeting.b2d88e00.png";